export default {
  label: {
    fontWeight: 600,
    fontSize: 21,
  },
};
